import "core-js/modules/es.array.reduce.js";
import { __spreadArrays } from "tslib";
import React from "react";
import has from "lodash/has";
import { createElementClass, createModifierClass } from "../helpers";
export var Blockquote = function Blockquote(_a) {
  var children = _a.children,
      _b = _a.types,
      types = _b === void 0 ? [] : _b;
  var blockquoteTag = "blockquote";

  var panelTypes = __spreadArrays(["note", "caution", "tip"], types);

  var isOneOfTypes = function isOneOfTypes(arg) {
    return !!arg && panelTypes.includes(arg);
  };

  var getPanelType = function getPanelType(child) {
    var type = has(child, "props.children[0].props.children[0].props") && child.props.children[0].props.children[0].props.value;
    return type && type.replace(":", "").toLowerCase() || "";
  };

  var createPanels = function createPanels(elem) {
    if (!elem) {
      return null;
    }

    return elem.map(function (elements, index) {
      return React.createElement("blockquote", {
        className: createElementClass(blockquoteTag) + " " + createModifierClass(getPanelType(elements[0]), blockquoteTag),
        key: index
      }, React.createElement("div", {
        className: createElementClass(blockquoteTag + "-content")
      }, elements));
    });
  };

  var modifiedChildren = null;

  if (children && Array.isArray(children)) {
    modifiedChildren = children.reduce(function (accumulator, curr) {
      var currType = getPanelType(curr);

      if (isOneOfTypes(currType)) {
        return __spreadArrays(accumulator, [[curr]]);
      }

      var len = accumulator.length - 1;

      if (len < 0 || !accumulator[len]) {
        return [[curr]];
      }

      if (!Array.isArray(accumulator[len])) {
        return [[accumulator], curr];
      }

      var newLastElement = __spreadArrays(accumulator[len], [curr]);

      return __spreadArrays(accumulator.slice(0, len), [newLastElement]);
    }, []);
  }

  return modifiedChildren ? React.createElement(React.Fragment, null, createPanels(modifiedChildren)) : null;
};